import React, {useEffect,useState,createContext} from 'react';
import { Children } from 'react';
//import {Mapagendamap} from '../pages/Mapagendamap'

export const Directionscontext = createContext();

export const DirectionscontextProvider = (props) => {
    const {children} = props;
    const [geoida,setageoida] = useState([]);
    const [geovolta,setageovolta] = useState([]);
    const [geolistaida,setalistageoida] = useState([]);
    const [geolistavolta,setalistageovolta] = useState([]);


    
    return(
        <Directionscontext.Provider value={{geoida,geovolta,geolistaida,geolistavolta,setageoida,setageovolta,
            setalistageoida,setalistageovolta}}>{children}</Directionscontext.Provider>
       // <Directionscontext.Consumer>{directionsida,directionsvolta}</Directionscontext.Consumer>
    );
};
